import cornerstoneDICOMImageLoader from "@cornerstonejs/dicom-image-loader";
import axios from "axios";

/**
 /**
 * Uses dicomweb-client to fetch metadata of a study, cache it in cornerstone,
 * and return a list of imageIds for the frames.
 *
 * Uses the app config to choose which study to fetch, and which
 * dicom-web server to fetch it from.
 *
 * @returns {string[]} An array of imageIds for instances in the study.
 */

export default async function createImageIdsAndCacheMetaData(caseId) {
  const BULK_UID = "7fe00010";
  
  // Use the provided caseId or fallback to a default (8)
  const currentCaseId = caseId || 8;

  const { data: instances } = await axios.get(`/api/file/wado-rs/${currentCaseId}/metadata`);

  const imageIds = instances.map((instanceMetaData) => {
    const prefix = "wadors:";
    const imageId = prefix + instanceMetaData[BULK_UID].BulkDataURI;

    cornerstoneDICOMImageLoader.wadors.metaDataManager.add(
        imageId,
        instanceMetaData
    );
    // const img = cornerstoneDICOMImageLoader.wadors.loadImage(imageId);
    // console.log("img", img);
    return imageId;
  });

  // we don't want to add non-pet
  // Note: for 99% of scanners SUV calculation is consistent bw slices

  return imageIds;
}
